import React from "react";

import { OrdersPolaris2 } from "../../components/order/OrdersPolaris2";
import { ORDER_FILTER_SUPPLIER } from "../../constants";
import { getPathFromRouter } from "../../helper";
import { USER_ROLE } from "../../variable";

export const SupplierOrdersPagePolaris2 = (...props) => {
    const path = React.useMemo(() => {
        return getPathFromRouter(props);
    }, [props]);

    return (
        <OrdersPolaris2
            role={USER_ROLE.Supplier}
            ordersFilter={ORDER_FILTER_SUPPLIER}
            path={path}
        />
    );
};
